export default {
  data() {
    return {
      modalTitle: '',
      modalWarnings: [],
      modalNotes: [],
      modalSections: []
    }
  },
  methods: {
    setModalNotes(notes) {
      this.modalNotes = notes
    },
    openModal(title, warnings, sections) {
      this.modalTitle = title
      this.modalWarnings = warnings
      this.modalSections = sections
      if (!this.modalNotes) {
        this.modalNotes = []
      }
      if (this.$refs && this.$refs.checkDataModal && this.$refs.checkDataModal.open) {
        this.$refs.checkDataModal.open()
      }
    },
    async checkFacilitiesData() {
      const type = this.panelType
      await this.loadAndNotifyError(async () => {
        const facilities = await this.fetchFacilities(type)
        const warnings = []
        const updatedAt = await this.getSnowReportUpdatedAt()

        if (!facilities.length) {
          warnings.push(this.$t('widgets.modal.warning.no_data'))
        }
        if (this.isOutdated(updatedAt, 14)) {
          warnings.push(this.$t('widgets.modal.warning.outdated_14'))
        }

        this.setModalNotes([])
        const sections = [
          {
            title: this.$t('widgets.modal.facilities.open_vs_total'),
            rows: this.buildFacilitiesRows(facilities)
          }
        ]

        this.openModal(this.facilityTitle(type), warnings, sections)
      }, this.$t('widgets.notifications.fetch_facilities_error'))
    },
    isFacilityOpen(facility) {
      const state = (facility.state || facility.status || '').toString().toLowerCase()
      return state.includes('open') || state.includes('in preparation') || state.includes('in-preparation')
    }
  }
}

